import type { ShopProfile } from '../types';

export function toShopProfile(raw: Record<string, unknown>): ShopProfile {
  const email =
    raw.email != null && String(raw.email).trim() !== '' ? String(raw.email) : '';
  const phone =
    raw.phone != null && String(raw.phone).trim() !== '' ? String(raw.phone) : null;

  const emailVerifiedRaw =
    (raw.emailVerified ?? raw.email_verified ?? raw.is_email_verified) as unknown;
  const phoneVerifiedRaw =
    (raw.phoneVerified ?? raw.phone_verified ?? raw.is_phone_verified) as unknown;

  const emailVerifiedAtRaw =
    (raw.emailVerifiedAt ?? raw.email_verified_at ?? raw.email_verifiedAt) as unknown;
  const phoneVerifiedAtRaw =
    (raw.phoneVerifiedAt ?? raw.phone_verified_at ?? raw.phone_verifiedAt) as unknown;

  const parsedRate =
    raw.costRate != null
      ? Number(raw.costRate)
      : raw.cost_rate != null
        ? Number(raw.cost_rate)
        : undefined;
  const can_delegate_popups =
    raw.can_delegate_popups === true || raw.can_delegate_popups === false
      ? Boolean(raw.can_delegate_popups)
      : undefined;
  return {
    id: String(raw.id ?? ''),
    email,
    phone,
    name: String(raw.name ?? ''),
    status: String(raw.status ?? ''),
    agentId:
      raw.agentId != null
        ? String(raw.agentId)
        : raw.agent_id != null
          ? String(raw.agent_id)
          : undefined,
    costRate: parsedRate,
    emailVerified: emailVerifiedRaw == null ? undefined : Boolean(emailVerifiedRaw),
    phoneVerified: phoneVerifiedRaw == null ? undefined : Boolean(phoneVerifiedRaw),
    emailVerifiedAt:
      emailVerifiedAtRaw == null ? undefined : String(emailVerifiedAtRaw),
    phoneVerifiedAt:
      phoneVerifiedAtRaw == null ? undefined : String(phoneVerifiedAtRaw),
    ...(can_delegate_popups !== undefined ? { can_delegate_popups } : {}),
  };
}
